import { gql } from '@apollo/client'

export const UPLOAD_FILE = gql`
  mutation UploadFile($input: UploadFileInput!) {
    uploadFile(input: $input) {
      clientMutationId
      file {
        id
        name
        mimeType
        downloadUrl
      }
    }
  }
`

export const DELETE_FILES = gql`
  mutation DeleteFiles($input: DeleteFilesInput!) {
    deleteFiles(input: $input) {
      clientMutationId
    }
  }
`

export const UPDATE_RESOURCE = gql`
  mutation UpdateResourceMutation($input: UpdateResourceInput!) {
    updateResource(input: $input) {
      clientMutationId
    }
  }
`
